import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const AuthModal = ({ isOpen, onClose, actionType = 'action' }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const messages = {
    cart: 'A client profile is required to acquire pieces in our collection.',
    favorites: 'Create a client profile to curate your personal favorites.',
    order: 'Please sign in to confirm your acquisition.',
    action: 'Authentication is required for this action.',
  };

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  const handleRegister = () => {
    onClose();
    navigate('/register');
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 bg-deepDark/80 backdrop-blur-sm flex items-center justify-center z-[100]">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="bg-surfaceDark border border-white/10 p-10 max-w-md w-full mx-4 relative shadow-2xl"
        >
          <button
            onClick={onClose}
            className="absolute top-6 right-6 text-textMuted hover:text-gold transition-colors duration-300"
          >
            <FaTimes size={20} />
          </button>

          <h2 className="text-3xl font-serif text-white mb-2 tracking-wide">Client Profile</h2>
          
          <p className="text-textMuted mb-8 font-light leading-relaxed text-sm">
            {messages[actionType] || messages.action}
          </p>

          <div className="space-y-4">
            <button
              onClick={handleLogin}
              className="w-full bg-gold text-deepDark font-bold py-3 text-xs tracking-widest uppercase hover:bg-white transition-colors duration-300"
            >
              Sign In
            </button>
            
            <button
              onClick={handleRegister}
              className="w-full border border-gold text-gold font-bold py-3 text-xs tracking-widest uppercase hover:bg-gold hover:text-deepDark transition-all duration-300"
            >
              Become a Client
            </button>
          </div>

          <button
            onClick={onClose}
            className="w-full mt-6 text-textMuted text-xs tracking-widest uppercase font-semibold py-2 hover:text-white transition-colors duration-300"
          >
            Return to Collection
          </button>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default AuthModal;
